<template>
	<el-dialog
		title="停止计提折旧"
		:visible.sync="dialogVisible"
		width="40%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-stop-dialog">
		<div class="msg">资产编号：{{ data.assetNo }}</div>
		<div class="msg">资产名称：{{ data.assetName }}</div>
		<div class="msg">累计折旧：¥{{ (data.accumulatedDepreciation * 10000).toLocaleString() }}.00万元</div>
		<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
			<el-row :gutter="20">
				<!-- 停止日期 -->
				<el-col :span="24">
					<el-form-item label="*停止日期" prop="stopDate">
						<el-date-picker
							v-model="form.stopDate"
							size="small"
							type="date"
							placeholder="Select date"
							style="width: 100%"
						/>
					</el-form-item>
				</el-col>

				<!-- 停止原因 -->
				<el-col :span="24">
					<el-form-item label="*停止原因" prop="stopReason">
						<el-radio-group v-model="form.stopReason">
							<el-radio label="资产报废">资产报废</el-radio>
							<el-radio label="资产出售">资产出售</el-radio>
							<el-radio label="资产盘亏">资产盘亏</el-radio>
							<el-radio label="其他">其他</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>

				<!-- 备注说明 -->
				<el-col :span="24">
					<el-form-item label="备注说明" prop="remark">
						<el-input
							type="textarea"
							v-model="form.remark"
							size="small"
							placeholder="请输入备注说明"
							:rows="4"
						/>
					</el-form-item>
				</el-col>

				<!-- 上传凭证 -->
				<el-col :span="24">
					<el-form-item label="上传凭证">
						<el-upload
							class="upload-demo"
							action="/api/file/upload"
							:on-success="handleUploadSuccess"
							:on-error="handleUploadError"
							:file-list="fileList"
							:limit="1"
							accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
						>
							<el-button size="small" type="primary">上传停止计提凭证</el-button>
							<div slot="tip" class="el-upload__tip">
								请上传PDF、Word或图片格式的文件
							</div>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<!-- 按钮 -->
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { stopAssetDepreciation } from '@/api/asset/assetLedgerApi';
	export default {
		name: 'AssetDepreciationStopDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
						this.fileList = [];
						this.form.certificatePath = '';
						// 可以在这里设置默认值，例如当前日期
						this.form.stopDate = new Date();
					});
				}
			},
		},
		data() {
			return {
				form: {
					stopDate: '',
					stopReason: '',
					remark: '',
					certificatePath: '',
					assetId: '',
				},
				rules: {
					stopDate: [
						{ required: true, message: '请选择停止日期', trigger: 'change' },
					],
					stopReason: [
						{ required: true, message: '请选择停止原因', trigger: 'change' },
					],
				},
				fileList: [],
			};
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleUploadSuccess(response, file, fileList) {
				if (response.code === 0) {
					this.form.certificatePath = response.data;
					this.$message.success('文件上传成功');
				} else {
					this.$message.error('文件上传失败');
				}
			},
			handleUploadError(err, file, fileList) {
				this.$message.error('文件上传失败');
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;
					const vo = {
						assetId: this.data.id,
						stopDate: this.form.stopDate,
						stopReason: this.form.stopReason,
						remark: this.form.remark,
						certificatePath: this.form.certificatePath
					};
					stopAssetDepreciation(vo)
						.then(() => {
							this.$message.success('停止计提折旧成功');
							this.$emit('updateSuccess');
							this.handleClose();
						})
						.catch(err => {
							console.log(err);
							this.$message.error('停止计提折旧失败');
						});
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-stop-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}

	.msg {
		color: #333;
		margin-bottom: 5px;
	}
</style>
